module.exports = {
  GROUPS: {
    CONTACT_INFORMATION: '8a8439f8-dfb2-4bcd-9390-f7f788602061',
    CONTACT_ACTIVITY: '2ad9bf36-d549-4fb1-81f9-369a81e0e3ad',
    COMPANY_INFORMATION: '8b2e1a59-f249-4858-b3ba-ac83c4ef7022',
    REGISTRATION_SUMMARY: 'd3764a9a-7d06-4493-9c70-32eecb7c161a',
    DEAL_INFORMATION: '03fbd6da-da65-48a5-85ec-467bb7de4c32'
  },
  EVENTS: {
    CREATE_ACCOUNT_CLICK: {
      event: 'CREATE_ACCOUNT_CLICK',
      tracking_properties: [{ key: 'get_started_create_account_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Create Account clicked',
      group_name: 'REGISTRATION_SUMMARY'
    },
    CREATE_ACCOUNT_PAGE_LOAD: {
      event: 'CREATE_ACCOUNT_PAGE_LOAD',
      tracking_properties: [{ key: 'get_started_create_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Create Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_UNDERSTAND_PAGE_LOAD: {
      event: 'INTRODUCTION_UNDERSTAND_PAGE_LOAD',
      tracking_properties: [{ key: 'introduction_understand_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Introduction Understand Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_UNDERSTAND_CLICK: {
      event: 'INTRODUCTION_UNDERSTAND_CLICK',
      tracking_properties: [{ key: 'introduction_understand_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Introduction Understand Page Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_CONTINUE_PAGE_LOAD: {
      event: 'INTRODUCTION_CONTINUE_PAGE_LOAD',
      tracking_properties: [{ key: 'introduction_continue_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Introduction Continue Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_CONTINUE_OPTIONAL_FIELD: {
      event: 'INTRODUCTION_CONTINUE_OPTIONAL_FIELD',
      tracking_properties: [{ key: 'introduction_continue_optional_field', data_type: 'INPUT' }],
      display_event_name: 'Introduction Continue Optional Field',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_CONTINUE_COUNTRY_FIELD: {
      event: 'INTRODUCTION_CONTINUE_COUNTRY_FIELD',
      tracking_properties: [{ key: 'introduction_continue_country_field', data_type: 'INPUT' }],
      display_event_name: 'Introduction Continue Country Field',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_CONTINUE_CLICK: {
      event: 'INTRODUCTION_CONTINUE_CLICK',
      tracking_properties: [{ key: 'introduction_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Introduction Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INTRODUCTION_BACK_CLICK: {
      event: 'INTRODUCTION_BACK_CLICK',
      tracking_properties: [{ key: 'introduction_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Introduction Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_BREIF_PAGE_LOAD: {
      event: 'BUSINESS_BREIF_PAGE_LOAD',
      tracking_properties: [{ key: 'business_brief_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Brief Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_BREIF_FIELD: {
      event: 'BUSINESS_BREIF_FIELD',
      tracking_properties: [{ key: 'business_brief_field', data_type: 'INPUT' }],
      display_event_name: 'Business Brief Field',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_BREIF_CONTINUE_CLICK: {
      event: 'BUSINESS_BREIF_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_brief_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Brief Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_BREIF_BACK_CLICK: {
      event: 'BUSINESS_BREIF_BACK_CLICK',
      tracking_properties: [{ key: 'business_brief_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Brief Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_LOCATION_PAGE_LOAD: {
      event: 'BUSINESS_LOCATION_PAGE_LOAD',
      tracking_properties: [{ key: 'business_location_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Location Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_LOCATION_SAME_AS_INCORPORATION: {
      event: 'BUSINESS_LOCATION_SAME_AS_INCORPORATION',
      tracking_properties: [{ key: 'business_location_same_as_incorporation', data_type: 'INPUT' }],
      display_event_name: 'Business Location Same As Incorparation',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_LOCATION_CONTINUE_CLICK: {
      event: 'BUSINESS_LOCATION_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_location_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Location Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_LOCATION_BACK_CLICK: {
      event: 'BUSINESS_LOCATION_BACK_CLICK',
      tracking_properties: [{ key: 'business_location_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Location Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_INDUSTRY_PAGE_LOAD: {
      event: 'BUSINESS_INDUSTRY_PAGE_LOAD',
      tracking_properties: [{ key: 'business_industry_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Location Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_INDUSTRY_SELECTION: {
      event: 'BUSINESS_INDUSTRY_SELECTION',
      tracking_properties: [{ key: 'business_industry_selection', data_type: 'INPUT' }],
      display_event_name: 'Business Location Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_INDUSTRY_CONTINUE_CLICK: {
      event: 'BUSINESS_INDUSTRY_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_industry_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Industry Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_INDUSTRY_BACK_CLICK: {
      event: 'BUSINESS_INDUSTRY_BACK_CLICK',
      tracking_properties: [{ key: 'business_industry_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Industry back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_PROFILE_PAGE_LOAD: {
      event: 'TAILOR_PROFILE_PAGE_LOAD',
      tracking_properties: [{ key: 'tailor_profile_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Profile Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_PROFILE_FINANCIAL_NEED: {
      event: 'TAILOR_PROFILE_FINANCIAL_NEED',
      tracking_properties: [{ key: 'tailor_profile_financial_need_selection', data_type: 'INPUT' }],
      display_event_name: 'Tailor Profile Financial Need Select',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_PROFILE_CONTINUE_CLICK: {
      event: 'TAILOR_PROFILE_CONTINUE_CLICK',
      tracking_properties: [{ key: 'tailor_profile_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Profile Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_PROFILE_BACK_CLICK: {
      event: 'TAILOR_PROFILE_BACK_CLICK',
      tracking_properties: [{ key: 'tailor_profile_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Profile Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_BUSINESS_COUNTRY_PAGE_LOAD: {
      event: 'TAILOR_BUSINESS_COUNTRY_PAGE_LOAD',
      tracking_properties: [{ key: 'tailor_business_country_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Business Country Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_BUSINESS_COUNTRY_CONTINUE_CLICK: {
      event: 'TAILOR_BUSINESS_COUNTRY_CONTINUE_CLICK',
      tracking_properties: [{ key: 'tailor_business_country_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Business Country Countinue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_BUSINESS_COUNTRY_BACK_CLICK: {
      event: 'TAILOR_BUSINESS_COUNTRY_BACK_CLICK',
      tracking_properties: [{ key: 'tailor_business_country_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Business Country Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_FUND_SOURCE_PAGE_LOAD: {
      event: 'TAILOR_FUND_SOURCE_PAGE_LOAD',
      tracking_properties: [{ key: 'tailor_fund_source_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Fund Source Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_FUND_SOURCE_SELECTION: {
      event: 'TAILOR_FUND_SOURCE_SELECTION',
      tracking_properties: [{ key: 'tailor_fund_source_selection', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Fund Source Selection',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_FUND_SOURCE_CONTINUE_CLICK: {
      event: 'TAILOR_FUND_SOURCE_CONTINUE_CLICK',
      tracking_properties: [{ key: 'tailor_fund_source_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Fund Source Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TAILOR_FUND_SOURCE_BACK_CLICK: {
      event: 'TAILOR_FUND_SOURCE_BACK_CLICK',
      tracking_properties: [{ key: 'tailor_fund_source_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Tailor Fund Source Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_STRUCTURE_PAGE_LOAD: {
      event: 'BUSINESS_STRUCTURE_PAGE_LOAD',
      tracking_properties: [{ key: 'business_structure_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Structure Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_STRUCTURE_NO_OF_EMPLOYEES: {
      event: 'BUSINESS_STRUCTURE_NO_OF_EMPLOYEES',
      tracking_properties: [{ key: 'business_structure_number_of_employees', data_type: 'INPUT' }],
      display_event_name: 'Business Structure No Of Employees',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_STRUCTURE_CONTINUE_CLICK: {
      event: 'BUSINESS_STRUCTURE_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_structure_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Structure Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_STRUCTURE_BACK_CLICK: {
      event: 'BUSINESS_STRUCTURE_BACK_CLICK',
      tracking_properties: [{ key: 'business_structure_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Structure Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_DETAIL_PAGE_LOAD: {
      event: 'BUSINESS_DETAIL_PAGE_LOAD',
      tracking_properties: [{ key: 'business_detail_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Detail Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_DETAIL_POSITION: {
      event: 'BUSINESS_DETAIL_POSITION',
      tracking_properties: [{ key: 'business_detail_position', data_type: 'INPUT' }],
      display_event_name: 'Business Detail Position',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_DETAIL_CONTINUE_CLICK: {
      event: 'BUSINESS_DETAIL_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_details_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Detail Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_DETAIL_BACK_CLICK: {
      event: 'BUSINESS_DETAIL_BACK_CLICK',
      tracking_properties: [{ key: 'business_details_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Detail Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_PAGE_LOAD: {
      event: 'BUSINESS_OWNER_PAGE_LOAD',
      tracking_properties: [{ key: 'business_owner_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_NO_OF_OWNERS: {
      event: 'BUSINESS_OWNER_NO_OF_OWNERS',
      tracking_properties: [{ key: 'business_owner_number_of_owners', data_type: 'INPUT' }],
      display_event_name: 'Business Owner no of owners',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_CONTINUE_CLICK: {
      event: 'BUSINESS_OWNER_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_owner_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_BACK_CLICK: {
      event: 'BUSINESS_OWNER_BACK_CLICK',
      tracking_properties: [{ key: 'business_owner_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_SELECTION_PAGE_LOAD: {
      event: 'BUSINESS_OWNER_SELECTION_PAGE_LOAD',
      tracking_properties: [{ key: 'business_owner_selection_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Selection Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_SELECTION_CONTINUE_CLICK: {
      event: 'BUSINESS_OWNER_SELECTION_CONTINUE_CLICK',
      tracking_properties: [{ key: 'business_owner_selection_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Selection Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    BUSINESS_OWNER_SELECTION_BACK_CLICK: {
      event: 'BUSINESS_OWNER_SELECTION_BACK_CLICK',
      tracking_properties: [{ key: 'business_owner_selection_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Business Owner Selection Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TERMS_N_CONDITION_PAGE_LOAD: {
      event: 'TERMS_N_CONDITION_PAGE_LOAD',
      tracking_properties: [{ key: 'terms_and_condition_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Terms and Condition Page Load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TERMS_N_CONDITION_CONTINUE_CLICK: {
      event: 'TERMS_N_CONDITION_CONTINUE_CLICK',
      tracking_properties: [{ key: 'terms_and_condition_continue_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Terms and Condition Continue Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    TERMS_N_CONDITION_BACK_CLICK: {
      event: 'TERMS_N_CONDITION_BACK_CLICK',
      tracking_properties: [{ key: 'terms_and_condition_back_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Terms and Condition Back Click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    AUTH_YOUR_BUSINESS_ID_VERIFICATION_PAGE_LOAD: {
      event: 'AUTH_YOUR_BUSINESS_ID_VERIFICATION_PAGE_LOAD',
      tracking_properties: [{ key: 'authorise_your_business_id_verification_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Auth your business id verification page load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    AUTH_YOUR_BUSINESS_ID_VERIFICATION: {
      event: 'AUTH_YOUR_BUSINESS_ID_VERIFICATION',
      tracking_properties: [{ key: 'authorise_your_business_id_verification', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Auth your business id verification',
      group_name: 'REGISTRATION_SUMMARY'
    },
    ID_VERIFICATION_PAGE_LOAD: {
      event: 'ID_VERIFICATION_PAGE_LOAD',
      tracking_properties: [{ key: 'id_verification_page_load', data_type: 'CURRENT_DATE' }],
      display_event_name: 'ID Verification page load',
      group_name: 'REGISTRATION_SUMMARY'
    },
    ID_VERIFICATION_FIRST_NEXT_CLICK: {
      event: 'ID_VERIFICATION_FIRST_NEXT_CLICK',
      tracking_properties: [{ key: 'id_verification_carousel_first_next_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Id Verification first next click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    ID_VERIFICATION_SECOND_NEXT_CLICK: {
      event: 'ID_VERIFICATION_SECOND_NEXT_CLICK',
      tracking_properties: [{ key: 'id_verification_carousel_second_next_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Id Verification second next click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    ID_VERIFICATION_BEGIN_CLICK: {
      event: 'ID_VERIFICATION_BEGIN_CLICK',
      tracking_properties: [{ key: 'id_verification_begin_click', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Id Verification begin click',
      group_name: 'REGISTRATION_SUMMARY'
    },
    INCORPORATION_COUNTRY_FIELD: {
      event: 'INCORPORATION_COUNTRY_FIELD',
      tracking_properties: [{ key: 'country', data_type: 'INPUT' }],
      display_event_name: 'Incorporation Country',
      group_name: 'COMPANY_INFORMATION'
    },
    REJECTION_REASON_FIELD: {
      event: 'REJECTION_REASON_FIELD',
      tracking_properties: [{ key: 'closed_lost_reason', data_type: 'INPUT' }],
      display_event_name: 'Rejection Reason',
      group_name: 'DEAL_INFORMATION'
    },
    DEAL_STAGE_REJECTED_FIELD: {
      event: 'DEAL_STAGE_REJECTED_FIELD',
      tracking_properties: [{ key: 'dealstage', data_type: 'INPUT' }],
      display_event_name: 'Deal Stage Rejected',
      group_name: 'DEAL_INFORMATION'
    },
    DEAL_STAGE_APPROVED_FIELD: {
      event: 'DEAL_STAGE_APPROVED_FIELD',
      tracking_properties: [{ key: 'dealstage', data_type: 'INPUT' }],
      display_event_name: 'Deal Stage Approved',
      group_name: 'DEAL_INFORMATION'
    },
    BUSINESS_TYPE_FIELD: {
      event: 'BUSINESS_TYPE_FIELD',
      tracking_properties: [{ key: 'business_type', data_type: 'INPUT' }],
      display_event_name: 'Business Type',
      group_name: 'CONTACT_INFORMATION'
    },
    CUSTOMER_SELECTED_INDUSTRY_FIELD: {
      event: 'CUSTOMER_SELECTED_INDUSTRY_FIELD',
      tracking_properties: [{ key: 'customer_selected_industry', data_type: 'INPUT' }],
      display_event_name: 'Customer Selected Industry',
      group_name: 'CONTACT_INFORMATION'
    },
    CUSTOMER_NAICS_INDUSTRY_FIELD: {
      event: 'CUSTOMER_NAICS_INDUSTRY_FIELD',
      tracking_properties: [{ key: 'customer_naics_industry', data_type: 'INPUT' }],
      display_event_name: 'Customer NAICS Industry',
      group_name: 'CONTACT_INFORMATION'
    },
    CUSTOMER_APPROVAL_DATE_FIELD: {
      event: 'CUSTOMER_APPROVAL_DATE_FIELD',
      tracking_properties: [{ key: 'customer_approval_date', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Customer Approval Date',
      group_name: 'REGISTRATION_SUMMARY'
    },
    EXTRA_INFORMATION_ASKED_FIELD: {
      event: 'EXTRA_INFORMATION_ASKED_FIELD',
      tracking_properties: [{ key: 'extra_information_asked_date', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Extra Information Asked',
      group_name: 'REGISTRATION_SUMMARY'
    },
    EXTRA_INFORMATION_SUBMITTED_FIELD: {
      event: 'EXTRA_INFORMATION_SUBMITTED_FIELD',
      tracking_properties: [{ key: 'extra_information_submitted_date', data_type: 'CURRENT_DATE' }],
      display_event_name: 'Extra Information Submitted',
      group_name: 'REGISTRATION_SUMMARY'
    },
    CUSTOMER_INTRODUCTION_CONTACT: {
      event: 'CUSTOMER_INTRODUCTION_CONTACT',
      tracking_properties: [
        { key: 'firstname', data_type: 'INPUT' },
        { key: 'lastname', data_type: 'INPUT' },
        { key: 'company', data_type: 'INPUT' },
        { key: 'mobilephone', data_type: 'INPUT' }
      ],
      display_event_name: 'Customer Introduction Contact',
      group_name: 'CONTACT_INFORMATION'
    }
  }
};
